import { useCallback } from "react";
import { useApiClient } from "../api/useApiClient";
import type { useAccion } from "./useAccion";
import { leerArchivoComoBase64, motivoRechazoAdjunto } from "../utils/archivoAdjunto";

/**
 * Subida del comprobante adicional, compartida por las dos bandejas que la
 * ofrecen (Contaduría en el Paso 1, Aprobador en el Paso 2). [NUEVO 08/09/2026]
 *
 * Vive en un hook y no duplicado en cada página para que la validación blanda
 * y la lectura del archivo sean exactamente las mismas en los dos lados.
 *
 * Dos detalles deliberados:
 *  - Si la validación local falla, se avisa y **no se llama al backend** — no
 *   tiene sentido subir 40 MB para que los rechace.
 *  - La LECTURA del archivo va adentro de `accion.ejecutar`, no antes: así un
 *   error al leer se muestra por el mismo cartel que un error del POST, en vez
 *   de quedar como una promesa rechazada en la consola.
 */
export function useAdjunto(accion: ReturnType<typeof useAccion>) {
  const api = useApiClient();

  return useCallback(
    async (reviewItemId: string, file: File) => {
      const motivo = motivoRechazoAdjunto(file);
      if (motivo) {
        accion.mostrarAviso(motivo);
        return;
      }
      await accion.ejecutar(
        async () => {
          const adjunto_base64 = await leerArchivoComoBase64(file);
          return api.subirAdjunto(reviewItemId, { adjunto_base64, adjunto_nombre: file.name });
        },
        { descripcion: "adjuntar el comprobante" }
      );
    },
    [api, accion]
  );
}
